export default __webpack_public_path__ + "static/media/0002.e05cb6aa.WAV";